"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternalLink = InternalLink;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function InternalLink(_ref) {
  var canViewLink = _ref.canViewLink,
      children = _ref.children,
      href = _ref.href,
      openInNewTab = _ref.openInNewTab;

  if (!canViewLink) {
    return (
      /*#__PURE__*/
      _react["default"].createElement("span", {
        "data-testid": "internal-link-span"
      }, children)
    );
  }

  var target = openInNewTab ? '_blank' : '';
  return (
    /*#__PURE__*/
    _react["default"].createElement("a", {
      href: href,
      target: target,
      "data-testid": "internal-link-a"
    }, children)
  );
}

InternalLink.propTypes = {
  canViewLink: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node.isRequired,
  href: _propTypes["default"].string.isRequired,
  openInNewTab: _propTypes["default"].bool
};
InternalLink.defaultProps = {
  openInNewTab: false
};